import { TallyApp } from './app';

document.addEventListener('DOMContentLoaded', () => new TallyApp());
